import React, { FC, MouseEvent, ReactNode } from 'react';
import styles from './Button.module.css';
import classNames from 'classnames';

interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  block?: boolean;
  children?: ReactNode;
  color?: string;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  outline?: boolean;
  disabled?: boolean;
  size?: string;
  rightIcon?: ReactNode;
  leftIcon?: ReactNode;
  tertiary?: boolean; // New prop
}

const Button: FC<ButtonProps> = ({
  rightIcon,
  leftIcon,
  active,
  'aria-label': ariaLabel,
  block,
  className,
  color = 'secondary',
  outline,
  size,
  tertiary, // New prop
  children,
  onClick,
  ...buttonProps
}) => {
  const btnOutlineColor: string = tertiary
    ? `btn-tertiary-${color}`
    : `btn${outline ? '-outline' : ''}-${color}`;

  const classes: string = classNames(
    className,
    'btn',
    btnOutlineColor,
    'd-flex flex-row align-items-center align-self-center',
    size ? `btn-${size}` : false,
    block ? 'd-block w-100' : false,
    {
      active,
      disabled: buttonProps.disabled,
    }
  );

  return (
    <button
      {...buttonProps}
      className={classes}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {leftIcon && <span className={styles.iconLeft}>{leftIcon}</span>}
      {children}
      {rightIcon && <span className={styles.iconRight}>{rightIcon}</span>}
    </button>
  );
};

export default Button;
